const FLEETS = [
  {
    tag: 'BEE',
    label: 'Bee',
    color: 'warning',
  },
  {
    tag: 'MOTTU',
    label: 'Mottu',
    color: 'warning',
  },
  {
    tag: 'UBER',
    label: 'Uber',
    color: 'warning',
  },
  {
    tag: 'CORREIOS',
    label: 'Correios',
    color: 'warning',
  },
  {
    tag: 'CORREIOS_EXPRESS',
    label: 'Correios Express',
    color: 'warning',
  },
  {
    tag: 'VIDDY_DELIVERIES',
    label: 'Viddy Entregas',
    color: 'warning',
  },
  {
    tag: 'LALAMOVE',
    label: 'Lalamove',
    color: 'warning',
  },
  {
    tag: 'ENTREGA99',
    label: '99Entrega',
    color: 'warning',
  },
  {
    tag: 'IFOOD_ENVIOS',
    label: 'iFood Envios',
    color: 'warning',
  },
  {
    tag: 'PROPRIA',
    label: `Frota`,
    color: 'info',
  },
];
export default FLEETS;

/**
 * Resolve o rótulo de exibição da transportadora.
 *
 * Normaliza a tag em maiúsculo porque delivery_method nem sempre é gravado
 * no mesmo case (ex.: viddy_deliveries). Sem correspondência no FLEETS,
 * devolve a própria tag legível em vez de esconder a informação.
 */
export const getFleetLabel = tag => {
  if (!tag) return '';

  const normalized = String(tag).toUpperCase();

  if (normalized === 'PROPRIA') return 'Alternativa';

  const fleet = FLEETS.find(item => item.tag === normalized);

  if (fleet?.label) return fleet.label;

  return normalized
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const deliveryFleets = [
  {
    id: 1,
    available: true,
    label: 'Bee',
    tag: 'BEE',
    icon: 'las la-motorcycle',
    value: true,
    col_padding: 'px-0 pr-lg-2',
    col_width: 2,
  },
  {
    id: 2,
    available: true,
    label: 'Mottu',
    tag: 'MOTTU',
    icon: 'las la-motorcycle',
    value: true,
    col_padding: 'px-0 pr-lg-2',
    col_width: 2,
  },
  {
    id: 5,
    available: true,
    label: 'Uber',
    tag: 'UBER',
    icon: 'las la-motorcycle',
    value: true,
    col_padding: 'px-0 pr-lg-2',
    col_width: 2,
  },
  {
    id: 6,
    available: true,
    label: 'Correios',
    tag: 'CORREIOS',
    icon: 'las la-motorcycle',
    value: true,
    col_padding: 'px-0 pr-lg-2',
    col_width: 2,
  },
  {
    id: 9,
    available: true,
    label: 'Correios Express',
    tag: 'CORREIOS_EXPRESS',
    icon: 'las la-motorcycle',
    value: true,
    col_padding: 'px-0 pr-lg-2',
    col_width: 2,
  },
  {
    id: 10,
    available: true,
    label: 'Viddy Entregas',
    tag: 'VIDDY_DELIVERIES',
    icon: 'las la-motorcycle',
    value: true,
    col_padding: 'px-0 pr-lg-2',
    col_width: 2,
  },
  {
    id: 7,
    available: true,
    label: 'Lalamove',
    tag: 'LALAMOVE',
    icon: 'las la-motorcycle',
    value: true,
    col_padding: 'px-0 pr-lg-2',
    col_width: 2,
  },
  {
    id: 8,
    available: true,
    label: '99Entrega',
    tag: 'ENTREGA99',
    icon: 'las la-motorcycle',
    value: true,
    col_padding: 'px-0 pr-lg-2',
    col_width: 2,
  },
  {
    id: 11,
    available: true,
    label: 'iFood Envios',
    tag: 'IFOOD_ENVIOS',
    icon: 'las la-motorcycle',
    value: true,
    col_padding: 'px-0 pr-lg-2',
    col_width: 2,
  },
  {
    id: 3,
    available: true,
    tag: 'PROPRIA',
    icon: 'las la-motorcycle',
    value: true,
    col_padding: 'px-0 pr-lg-2',
    col_width: 2,
  },
  /*
  {
    id: 4,
    available: true,
    label: 'Retirar na Loja',
    tag: 'RETIRAR',
    icon: 'las la-box',
    value: false,
    col_padding: 'px-0 pr-lg-2',
    col_width: 2,
  },
  */
];
